import React from 'react';
import { createPortal } from 'react-dom';
export const Portal = (props) => {
    const { children, forwardRef, as, ...rest } = props;
    if (!as) {
        return createPortal(children, document.body);
    }
    const portalProps = {
        'data-testid': 'portal',
        ref: forwardRef,
        ...rest,
    };
    return createPortal(React.createElement(as, portalProps, children), document.body);
};
